import initCharterTabs from '../../scripts/initCharterTabs';

export default {
	data() {
		return {
			charterContentType: 'first'
		}
	},
    methods: {
        altCharterContentType () {
            const customCharterType = document.querySelectorAll('.custom-charter-type');
            if (customCharterType.length) {
                const url = window.location.pathname;
                if  (url === '/deposits/terms/nadezhnyy-premium/') {
                    this.charterContentType = 'second';
                } else if (url === '/deposits/terms/nadezhnyy-promo/') {
                    this.charterContentType = 'third';
                } else if (url === '/deposits/terms/nadezhnyy-vip/') {
                    this.charterContentType = 'fourth';
                }
                // ..
            }
        }
    },
	mounted() {
		initCharterTabs();
        this.altCharterContentType();
	}
}
